module.exports = __webpack_public_path__ + "e3fdeee2470b796412891bde7e9cca07.svg";